import axios from "axios";

export const getAll = async (page, dispatchApi) => {
  axios.get(`courses?page=${page}`).then(({ data }) =>
    dispatchApi({
      type: "FETCHED_COURSE",
      data,
    })
  );
};
export const get = (id) => axios.get(`courses/${id}`, id);
export const add = (course) => axios.post("courses", course);
export const update = (course) => axios.post(`courses/${course.get("id")}`, course);
export const remove = (id) => axios.delete(`courses/${id}`);
